import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const footerLinks = {
  company: [
    { label: "Why We Exist", href: "/why-we-exist" },
    { label: "About Us", href: "/about" },
    { label: "Founder Story", href: "/founder" },
    { label: "Blog", href: "/blog" },
  ],
  services: [
    { label: "How We Help", href: "/how-we-help" },
    { label: "What We Do", href: "/what-we-do" },
    { label: "What We Build", href: "/what-we-build" },
    { label: "Our Process", href: "/process" },
  ],
  engage: [
    { label: "Who We Help", href: "/who-we-help" },
    { label: "Pricing", href: "/pricing" },
    { label: "Engagement Types", href: "/engagements" },
    { label: "For Investors", href: "/investors" },
    { label: "Contact", href: "/contact" },
  ],
  legal: [
    { label: "Terms & Conditions", href: "/terms" },
  ],
};

export const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container-wide section-padding-sm">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-4 lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2 mb-4 group">
              <div className="overflow-hidden">
                <img 
                  src="/logo.png" 
                  alt="Let's Build Startup" 
                  className="w-12 h-12 object-contain rocket-logo"
                />
              </div>
              <span className="font-serif text-xl font-medium group-hover:text-primary-foreground/80 transition-colors">Let's Build Startup</span>
            </Link>
            <p className="text-primary-foreground/70 text-sm leading-relaxed max-w-xs">
              A Gritbyte Labs Venture. Founder-led execution partner for early-stage and growth-stage founders.
            </p>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-medium text-sm mb-4">Company</h4>
            <ul className="space-y-2.5">
              {footerLinks.company.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-medium text-sm mb-4">Services</h4>
            <ul className="space-y-2.5">
              {footerLinks.services.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Engage */}
          <div>
            <h4 className="font-medium text-sm mb-4">Work With Us</h4>
            <ul className="space-y-2.5">
              {footerLinks.engage.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-medium text-sm mb-4">Legal</h4>
            <ul className="space-y-2.5">
              {footerLinks.legal.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-primary-foreground/10" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-primary-foreground/60">
            © {new Date().getFullYear()} Let's Build Startup. A Gritbyte Labs Venture. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/contact"
              className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors inline-flex items-center gap-1"
            >
              Submit Your Wishlist
              <ArrowUpRight className="h-3.5 w-3.5" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
